import cx from 'classnames';
import { useContext } from 'react';
import FeatureBranch from '@/common/FeatureBranch';
import PageFooter from '@/common/PageFooter';
import PageHeader from '@/common/PageHeader';
import BackgroundOverlay from '@/home/BackgroundOverlay';
import InternalLinks from '@/home/InternalLinks';
import {
  FinanceTradePromoTiles,
  ValueInsurancePromoTiles
} from '@/home/PromoTiles';
import RecommendedCarousels from '@/home/RecommendedCarousels';
import HideOnNative from '~/components/common/HideOnNative';
import { useIsLoggedIn } from '~/context/common/UserContext';
import { useGetIsReturnUser } from '~/context/home/GlobalContext';
import ModalContext from '~/context/home/ModalContext';
import useDisplayRecommendedCarousels from '~/hooks/home/useDisplayRecommendedCarousels';
import NativeError from '~/native/NativeError';
import AffordableCars from './AffordableCars';
import Hero from './Hero';
import {
  ExpandedSectionContent,
  SectionDark,
  SectionContent,
  SectionLight
} from './HomeContainer.styles';
import Modals from './Modals';
import NewPriceBanner from './NewPriceBanner';
import PopularBodyStyles from './PopularBodyStyles';
import PopularModels from './PopularModels';
import CVTBanner from './PromoCVT/CVTBanner';
import TopCarousels from './TopCarousels';
import CreditKarmaPromoBanner from '../common/CreditKarmaPromoBanner';

export default function HomeContainer() {
  const isReturningUser = useGetIsReturnUser();
  const isLoggedIn = useIsLoggedIn();
  const { setCreditKarmaPromoModalOpen } = useContext(ModalContext);
  const shouldDisplayRecommendedCarousels = useDisplayRecommendedCarousels();

  return (
    <>
      <BackgroundOverlay />
      <HideOnNative>
        <PageHeader isLoggedIn={isLoggedIn} />
      </HideOnNative>
      <NativeError />
      <FeatureBranch />
      <main>
        <CreditKarmaPromoBanner
          setCreditKarmaPromoModalOpen={setCreditKarmaPromoModalOpen}
        />
        <Hero />
        <SectionLight className="gap-40">
          <SectionContent className={isReturningUser ? 'hidden' : ''}>
            <CVTBanner />
            <PopularBodyStyles />
          </SectionContent>

          {isReturningUser && (
            <ExpandedSectionContent>
              <TopCarousels />
            </ExpandedSectionContent>
          )}

          <ExpandedSectionContent>
            {!isReturningUser && <FinanceTradePromoTiles />}
            <NewPriceBanner />
          </ExpandedSectionContent>
        </SectionLight>

        <SectionDark
          className={cx({
            'm:pb-40': !isReturningUser
          })}
        >
          <ExpandedSectionContent>
            {isReturningUser && <PopularBodyStyles />}
            <AffordableCars />
          </ExpandedSectionContent>
        </SectionDark>

        {shouldDisplayRecommendedCarousels && (
          <SectionLight>
            <ExpandedSectionContent>
              <RecommendedCarousels />
            </ExpandedSectionContent>
          </SectionLight>
        )}

        <SectionDark
          className={cx({
            'pt-40': !isReturningUser
          })}
        >
          <ExpandedSectionContent>
            <ValueInsurancePromoTiles />
          </ExpandedSectionContent>
        </SectionDark>

        <SectionLight>
          <ExpandedSectionContent>
            <PopularModels />
          </ExpandedSectionContent>
          {!isReturningUser && (
            <HideOnNative>
              <InternalLinks />
            </HideOnNative>
          )}
        </SectionLight>
      </main>
      <HideOnNative>
        <PageFooter />
      </HideOnNative>
      <Modals />
    </>
  );
}
